import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { DeletionJob } from "@/types/data-deletion";
import { DeletionJobStatusView } from "./DeletionJobStatusView";

interface DeletionJobStatusDialogProps {
  jobId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCompleted?: (job: DeletionJob) => void;
}

/**
 * Standalone status dialog — used by the audit log to inspect a job. The
 * confirm → start → poll flow uses {@link useDeletionFlow} instead.
 */
export const DeletionJobStatusDialog: React.FC<
  DeletionJobStatusDialogProps
> = ({ jobId, open, onOpenChange, onCompleted }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-xl overflow-y-auto">
      {jobId ? (
        <DeletionJobStatusView
          key={jobId}
          jobId={jobId}
          onCompleted={onCompleted}
          onClose={() => onOpenChange(false)}
        />
      ) : null}
    </DialogContent>
  </Dialog>
);
